import { render } from "./ReceiptModal.vue?vue&type=template&id=4278f439"
import script from "./ReceiptModal.vue?vue&type=script&lang=js"
export * from "./ReceiptModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\work\\prj\\asan\\asan_tpps_fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__